import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { KINDS, fmtMs, fmtRate, fmtWib, level } from "./monUtil";

const EP_KEY = "orx_health_episodes";
const readKey = (uid) => `orx_health_read_${uid || "anon"}`;
const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };

// Active conditions → alerts; each condition keeps its start time until it recovers (one alert per incident).
function toAlerts(o) {
  const conds = [];
  Object.keys(KINDS).forEach((k) => {
    const s = o.latency?.[k];
    if (level(k, s) === "crit") conds.push({ cond: `crit:${k}`, kind: "health_crit", label: `Kritis · ${KINDS[k].label}`, title: k === "ws" ? `error ${fmtRate(s.error_rate)} · ${s.errors} error server` : `p95 ${fmtMs(s.p95_ms)} · error ${fmtRate(s.error_rate)}`, sub: `${s.count} operasi dalam 15 menit terakhir`, to: k === "ws" ? "/monitoring/websocket" : `/monitoring/latency?kind=${k}` });
  });
  (o.system || []).filter((i) => !i.online).forEach((i) => conds.push({ cond: `offline:${i.instance}`, kind: "health_offline", label: "Instance offline", title: i.instance, sub: `Snapshot terakhir ${fmtWib(i.at, { timeStyle: "short" })}`, to: "/monitoring/system" }));
  const prev = load(EP_KEY, {}); const now = new Date().toISOString(); const eps = {};
  conds.forEach((c) => { eps[c.cond] = prev[c.cond] || now; });
  localStorage.setItem(EP_KEY, JSON.stringify(eps));
  return conds.map((c) => ({ ...c, at: eps[c.cond], key: `${c.cond}:${eps[c.cond]}` }));
}

export function useHealthAlerts(enabled, uid) {
  const [items, setItems] = useState([]); const [read, setRead] = useState(() => new Set(load(readKey(uid), [])));
  const refresh = useCallback(() => {
    if (!enabled) return;
    api.get("/platform/monitoring/overview", { params: { window: "15m" } }).then((r) => setItems(toAlerts(r.data))).catch(() => {});
  }, [enabled]);
  useEffect(() => { setRead(new Set(load(readKey(uid), []))); }, [uid]);
  useEffect(() => {
    if (!enabled) return undefined;
    refresh(); const t = setInterval(() => { if (!document.hidden) refresh(); }, 60000);
    return () => clearInterval(t);
  }, [enabled, refresh]);
  const mark = useCallback((keys) => setRead((p) => { const n = new Set(p); keys.forEach((k) => n.add(k)); localStorage.setItem(readKey(uid), JSON.stringify([...n].slice(-200))); return n; }), [uid]);
  return { items: items.map((a) => ({ ...a, read: read.has(a.key) })), refresh, mark };
}
